import { ShowroomService } from '@sm360/widget-commons-vehicle';

/**
 * Service to fetch/get and keep in memory the TradeIn save in the Showroom API
 */
class ShowroomTradeInService {
    constructor() {
        /**
         * @type {Object} The ShowroomAPI TradeIn object
         */
        this.tradeIn = null;
    }

    /**
     * Fetch on the ShowroomAPI the tradeIn for the logger account and set it as a class variable
     * @return {Promise} A Promise the gives the TradeIn
     */
    fetchTradeIn() {
        return ShowroomService.loadTradeInVehicle().then((tradeIn) => {
            delete tradeIn.dealerIds;
            this.tradeIn = tradeIn;
            return Promise.resolve(tradeIn);
        });
    }

    /**
     * If set, returns the TradeIn otherwise fetch it first
     * @return {Promise} A Promise the gives the TradeIn
     */
    getTradeIn() {
        if (this.tradeIn) {
            return Promise.resolve(this.tradeIn);
        }
        return this.fetchTradeIn();
    }
}

export default new ShowroomTradeInService();



// WEBPACK FOOTER //
// ./src/services/ShowroomTradeInService/ShowroomTradeInService.js